import hash from 'hash-sum'
import { OFFER_TYPE, OFFER_STATUS, VALIDATION_STATUS } from '@/helpers/constants'
import {
  SET_OFFER,
  SET_OFFER_ITEM,
  SET_OFFER_PRODUCT_ITEM,
  SET_OFFER_PRODUCT_SELECTION,
  SET_OFFER_PAYMENT_METHOD_SELECTION,
  SET_OFFER_PAYMENT_DAY,
  SET_OFFER_ADDITIONAL_SERVICE,
  SET_PACKAGE_ITEM,
  SET_OFFER_BASEPRICE_ITEM,
  SET_OFFER_STANDARD_WEIGHT_LIST,
  SET_OFFER_DISCOUNT,
  SET_OFFER_DISPERSION,
  SET_SERVICE_POINT_SHIPMENTS,
  SET_FAV_SERVICE_POINT,
  SET_TARIFF_MODEL,
  SET_TYPE_AND_VAL_STATUS_OFFER,
  UPDATE_PRODUCT_DISCOUNT,
  UPDATE_PRODUCT_ZONE_KG_PRICE,
  SET_ALL_DISCOUNTS_OF_PRODUCT,
  SET_PRODUCT_CURRENT_WEIGHT_LIST,
  UPDATE_PRODUCT_BASE_PRICES,
  RESET_VALIDATED_OFFER_STATUS,
} from './mutations'

const targetMutations = [
  SET_OFFER_ITEM,
  SET_OFFER_PRODUCT_ITEM,
  SET_OFFER_PRODUCT_SELECTION,
  SET_OFFER_PAYMENT_METHOD_SELECTION,
  SET_OFFER_PAYMENT_DAY,
  SET_OFFER_ADDITIONAL_SERVICE,
  SET_PACKAGE_ITEM,
  SET_OFFER_BASEPRICE_ITEM,
  SET_OFFER_STANDARD_WEIGHT_LIST,
  SET_OFFER_DISCOUNT,
  SET_OFFER_DISPERSION,
  SET_SERVICE_POINT_SHIPMENTS,
  SET_FAV_SERVICE_POINT,
  SET_TARIFF_MODEL,
  SET_TYPE_AND_VAL_STATUS_OFFER,
  UPDATE_PRODUCT_DISCOUNT,
  UPDATE_PRODUCT_ZONE_KG_PRICE,
  SET_ALL_DISCOUNTS_OF_PRODUCT,
  SET_PRODUCT_CURRENT_WEIGHT_LIST,
  UPDATE_PRODUCT_BASE_PRICES,
]

const createOfferHash = offer => {
  const offerWithoutIgnoredKeys = { ...offer }
  delete offerWithoutIgnoredKeys.status
  delete offerWithoutIgnoredKeys.validationStatus
  delete offerWithoutIgnoredKeys.contract
  delete offerWithoutIgnoredKeys.step
  return hash(offerWithoutIgnoredKeys)
}

const isEditingValidatedOffer = offer =>
  offer.type !== OFFER_TYPE.A && offer.status === OFFER_STATUS.VALIDATED

const commitMutationAfterEditValidatedOffer = (offer, store) => {
  if (offer.validationStatus === VALIDATION_STATUS.APPROVED) {
    store.commit('process/setShowEditValidatedOfferDialog')
  } else if (
    offer.validationStatus === VALIDATION_STATUS.REJECTED ||
    offer.validationStatus === VALIDATION_STATUS.RETURNED
  ) {
    store.commit(`offer/${RESET_VALIDATED_OFFER_STATUS}`)
  }
}

const namespaceRegex = /offer\/(.*)/
const removeMutationNamespace = mutationType => {
  const [, mutationWithoutNamespace] = mutationType.match(namespaceRegex)
  return mutationWithoutNamespace
}

export const offerPlugin = store => {
  let lastOfferHash
  store.subscribe((mutation, state) => {
    if (namespaceRegex.test(mutation.type)) {
      const mutationWithoutNamespace = removeMutationNamespace(mutation.type)
      if (mutationWithoutNamespace === SET_OFFER) {
        lastOfferHash = createOfferHash(state.offer.offer)
      } else if (
        isEditingValidatedOffer(state.offer.offer) &&
        targetMutations.includes(mutationWithoutNamespace)
      ) {
        const newOfferHash = createOfferHash(state.offer.offer)
        if (lastOfferHash !== newOfferHash) {
          commitMutationAfterEditValidatedOffer(state.offer.offer, store)

          lastOfferHash = newOfferHash
        }
      }
    }
  })
}
